import $api from '../../http'

type GetPricingType = {
    languageCode: string
    currencyCode?: 'SEK' | 'USD' | 'EUR'
}
export const getPricingQuery = async (payload: GetPricingType) => {
    try {
        const res = await $api.api.subscriptionsPublicControllerGetSubscriptions(payload);
        return res.data.data;
    } catch (error) {
        return [];
    }
}

export const getSubscriptionQuery = async (payload: {
	subscriptionId: string
	frontendUrl: string
}) => {
	try {
		const res = await $api.api.subscriptionsControllerCreateSubscription({
			isRegularPayment: true,
			paymentService: 'stripe_new',      // Платёжная система
			subscriptionId: payload.subscriptionId,
			// frontendUrl: payload.frontendUrl,  // This field does not exist on the DTO in this version
		})

		return res.data.data  // Возвращает PaymentOrderResponse
	} catch (error) {
		console.log(error)
	}
}

export const getSubscriptionAccountQuery = async () => {
    try {
        const res = await $api.api.paymentsControllerGetAccount()

        return res.data.data
    } catch (error) {
        console.log(error)
    }
}
